import { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import { ClearIcon } from '@anyx/shared-icons';

export interface ComboboxClearButtonProps extends ComponentPropsWithoutRef<'button'> {
  onClear?: () => void;
}

export const ComboboxClearButton = ({
  className,
  onClear,
  onClick,
  ...rest
}: ComboboxClearButtonProps) => {
  return (
    <button
      {...rest}
      type="button"
      className={classNames('flex items-center justify-center', className)}
      onClick={(e) => {
        e.stopPropagation();
        onClear?.();
        onClick?.(e);
      }}
      onMouseDown={(e) => e.preventDefault()}
      tabIndex={-1}
      aria-label="Clear"
    >
      <ClearIcon className="fill-gray-5 h-3.5 w-3.5 cursor-pointer" />
    </button>
  );
};
